import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { sendToVercelAnalytics } from './vitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Home from './home';
import Login from './login';
import Appuntamenti from './appuntamenti';
import Profilo from './profilo';
import Admin from './Admin/Admin';
import InfoCard from './info';
import Soldi from './soldi';
const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/partite",
    element: <Appuntamenti />,
  }, 
  {
    path: "/profilo",
    element: <Profilo />,
  }, 
  {
    path: "/admin",
    element: <Admin />,
    
  }, 
  {
    path: "/info/:activityId",
    element: <InfoCard />,
  }, 
  {
    path: "/soldi",
    element: <Soldi />,
  }, 
]);




ReactDOM.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals(sendToVercelAnalytics);
